import Container, { type ContainerProps } from '@mui/material/Container';

/** Consistent page width/vertical rhythm for every route below the navbar. */
export function PageContainer({ sx, children, ...props }: ContainerProps) {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 5 }, ...sx }} {...props}>
      {children}
    </Container>
  );
}
